import React, {useEffect, useState} from 'react'
import Header from 'src/layouts/Header';
import Footer from 'src/layouts/Footer';
import {useDispatch} from 'react-redux';
import axios from 'src/api/axios';
import useSEO from 'src/hooks/useSEO';

const Logout = () => {
  useSEO({
    title: 'Signing Out - SphynxPlace.com',
    description: 'Securely signing out of your SphynxPlace account.',
    robots: 'noindex, nofollow',
  });
  const dispatch = useDispatch();
  const [status, setStatus] = useState('Signing out...');
  const [progress, setProgress] = useState(0);
  
  useEffect(() => {
    const performLogout = async () => {
      try {
        setStatus('Signing out...');
        setProgress(30);
        
        // Pozovi backend logout da se token revoke-uje
        await axios.post('/api/logout', {}, { disableNotification: true });
        
        setProgress(60);
        setStatus('Clearing session...');
        
        // Kratka pauza za smooth animaciju
        await new Promise(resolve => setTimeout(resolve, 300));
        
      } catch (error) {
        // Ignoriši greške - i dalje nastavi sa logout-om
        console.log('Logout API call failed, continuing with local logout');
      } finally {
        setProgress(80);
        setStatus('Redirecting...');
        
        // Uvek izvrši lokalni logout
        dispatch({ type: 'LOGOUT' });
        
        // Signaliziraj drugim tabovima da se odjave
        localStorage.setItem('logout', Date.now().toString());
        
        setProgress(100);
        
        // Smooth redirect sa fade-out efektom
        setTimeout(() => {
          window.location.href = '/';
        }, 800);
      }
    };

    performLogout();
  }, [dispatch]);
  
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <div className="bg-[#F7F7F7] flex-1 flex items-center justify-center py-4">
        <div className="container mx-auto px-4 w-full flex justify-center">
          <div className="max-w-[600px] w-full text-center animate-fadeIn">
            {/* Spinner */}
            <div className="flex justify-center mb-8">
              <div className="relative">
                <div className="w-24 h-24 border-4 border-purple-100 rounded-full"></div>
                <div className="w-24 h-24 border-4 border-[#832EE6] border-t-transparent rounded-full animate-spin absolute top-0 left-0"></div>
              </div>
            </div>
            
            {/* Status Message */}
            <h2 className="text-[24px] md:text-[32px] font-bold text-[#0D0D0D] mb-4">
              {status}
            </h2>
            
            <p className="text-gray-600 mb-8 text-sm md:text-base leading-relaxed">
              Please wait while we securely sign you out...
            </p>
            
            {/* Progress Bar */}
            <div className="max-w-md mx-auto mb-4">
              <div className="w-full bg-gray-200 rounded-full h-2 mb-2">
                <div 
                  className="bg-[#832EE6] h-2 rounded-full transition-all duration-500 ease-out"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
              <p className="text-sm text-gray-500">
                {progress}%
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        
        .animate-fadeIn {
          animation: fadeIn 0.4s ease-out;
        }
      `}</style>
    </div>
  )
}

export default Logout